import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";

 const deleteblog = createAsyncThunk('deleteblog', async (id, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/blog/deleteblogdata`, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem("token"),
                'x-blog-id': id,
            }
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "Failed To Delete Data");
    }
});

const deleteblogslice = createSlice({
    name: 'deleteblog',
    initialState: {
        loading: false,
        error: false,
        data: null,
        isError: false,
        isSucces: false 
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteblog.pending, (state) => {
                state.loading = true;
                state.isError = false;
                state.isSucces = false;
                state.error = false;
                state.data = null;
            })
            .addCase(deleteblog.fulfilled, (state, action) => {
                state.loading = false;
                state.isError = false;
                state.isSucces = true;
                state.error = false;
           
            })
            .addCase(deleteblog.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.isSucces = false;
                state.error = action.payload || "Failed To Delete Data";
            });
    }
});

export default deleteblogslice.reducer;
export {deleteblog};